import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=eae38bb4&lang=pug"
import script from "./canvas.vue?vue&type=script&lang=js"
export * from "./canvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports